export default __webpack_public_path__ + "static/media/search.6a4e4ac7.svg";